/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-branch-public': {
    width: 100,
    height: 100,
    viewBox: '0 0 64 64',
    data: '<path pid="0" d="M57.414 30.586l-24-24a2 2 0 00-2.828 0L20 17.172V14a2 2 0 00-4 0v7.172l-9.414 9.414a2 2 0 102.828 2.828L12 30.828V56a2 2 0 002 2h36a2 2 0 002-2V30.828l2.586 2.586c.391.391.902.586 1.414.586s1.023-.195 1.414-.586a2 2 0 000-2.828z"/>'
  }
})
